var path = 'components/json-form.tpl.html';
var html = " <react-component name=ReactSchemaForm props=formProps watch-depth=value></react-component>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/json-form.tpl.html
// module id = 1391
// module chunks = 1